/* The short Meshfam menu wraps on tablet; no hidden overflow submenu. */
document.body.classList.add('is-dropdown-loaded');
